<script lang="ts">
    import Link from "svelte-link";
    import { Col, Row } from "sveltestrap";
    import { href } from "../../../utils/Constant/Constant";
    import data from "../../../Data/SearchResult/SearchResult.json"
    import AllDataRightSide from "./AllDataRightSide.svelte";
    import SearchRatingStar from "./SearchRatingStar.svelte";
    import SearchPagination from "./SearchPagination.svelte";
    import {searchResults} from "../../../store"
    let setSearchResult:string 
    searchResults.subscribe((value)=>{
        setSearchResult = value
    })
</script>
<div class="search-links tab-pane fade {setSearchResult === "all-link" ? "show active" :""}" id="all-link" >
    <Row>
        <Col xl="6" class="box-col-6">
            <p class="pb-4">{'About 6,000 results (0.60 seconds)'}</p>
            {#each data.alldata as item}
                <div class="info-block">
                    <h6>{item.title}</h6>
                    <Link href={href}>{item.link}</Link>
                    <p>{item.detail}</p>
                    <div class="star-ratings">
                        <ul class="search-info">
                            <SearchRatingStar />
                            <li>{item.info}</li>
                            <li>{item.info2}</li>
                            <li>{item.info3}</li>
                        </ul>
                    </div>
                </div>
            {/each}
        </Col>
        <AllDataRightSide />
        <SearchPagination />
  </Row>
</div>